import { GTMEvent, PageViewEvent } from "./GoogleTagManagerIntegration";
import { SwarovskiOptikLocale, SwarovskiOptikSegmentShort, getIsoCodeWithIntFallback } from "@swo/shared";
import { SwarovskiOptikPage } from "@swo/sitemap-service";
import { SwarovskiOptikLocaleFrontend } from "@swo/storefront";

export type Pushable = {
  push: () => void;
};

export function pushableEvent(eventPromise: Promise<GTMEvent>): { push: () => Promise<void> } {
  return {
    push: () => {
      return eventPromise
        .then(event => {
          //@ts-expect-error
          if (window.dataLayer && typeof window.dataLayer.push === "function") {
            //@ts-expect-error
            window.dataLayer.push(event);
          } else {
            console.debug(`GTM event: `, event);
          }
        })
        .catch(err => {
          console.debug(`Failed to push GTM event: `, err);
        });
    },
  };
}

export function pushableEventOfPure(event: GTMEvent) {
  return pushableEvent(Promise.resolve(event));
}

export function pageViewEvent(data: {
  locale: SwarovskiOptikLocaleFrontend;
  segment: SwarovskiOptikSegmentShort;
  page: SwarovskiOptikPage;
}): PageViewEvent {
  return {
    event: "pageview",
    language: data.locale.language.isoCode.toLowerCase(),
    country: getIsoCodeWithIntFallback(data.locale.country),
    consumerType: data.segment.key,
    pageType: data.page.__typename,
    //@ts-expect-error
    pageId: data.page?.pageId,
  };
}
